module.exports = __webpack_public_path__ + "img/A58A2612.3a05389e.jpg";